var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import Select from '../../components/Select';
import Input from '../../components/Input';
import Button from '../../components/Button';
import Translate from '../../components/Translate';

var Settings = function Settings(_ref) {
  var items = _ref.items,
      onChange = _ref.onChange,
      onSave = _ref.onSave;

  var types = {
    checkbox: Checkbox,
    select: Select,
    input: Input
  };

  return React.createElement(
    'div',
    { className: 'SettingsWrapper' },
    items && items.map(function (item, key) {
      var Component = types[item.type];

      var defaultValue = item.defaultValue,
          props = _objectWithoutProperties(item, ['defaultValue']);

      return Component && React.createElement(Component, _extends({ key: key }, props, { onChange: onChange }));
    }),
    React.createElement(
      Button,
      { onClick: onSave, className: 'button primary' },
      React.createElement(Translate, { id: 'action.save', defaultMessage: 'Save' })
    )
  );
};

Settings.propTypes = {
  /** Array of settings item */
  items: PropTypes.array,
  /** Function to call when a change is detected */
  onChange: PropTypes.func.isRequired,
  /** Function to call when user press save button */
  onSave: PropTypes.func.isRequired
};
Settings.defaultProps = {
  items: []
};

export default Settings;